import { avatarColor } from '@quadro/domain';
import { useWorkspace } from '../state/workspace';

export function Avatar({ id }: { id: string | null | undefined }) {
  const { person } = useWorkspace();
  if (!id) return null;
  const p = person(id);
  const initials = p.name.split(/\s+/).filter(Boolean).map(s => s[0]).slice(0, 2).join('').toUpperCase() || '?';
  return <span className="avatar" style={{ background: avatarColor(id, p.color) }} title={p.name}>{initials}</span>;
}
